import { render, staticRenderFns } from "./ResumoAcordoTricard.vue?vue&type=template&id=7397db80&scoped=true"
import script from "./ResumoAcordoTricard.vue?vue&type=script&lang=js"
export * from "./ResumoAcordoTricard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7397db80",
  null
  
)

export default component.exports